<h2 class="text-tertiary text-w-700 d-flex justify-content-between uppercase">
  <span mat-dialog-title>{{
    multilingualService.langMap?.LABEL_ADD_NEW_PAYMENT_METHOD
  }}</span>

  <button
    mat-dialog-close
    class="close"
    mat-icon-button
    [attr.aria-label]="multilingualService?.langMap?.LABEL_CLOSE_DIALOG"
  >
    <mat-icon class="icon-cross"></mat-icon>
  </button>
</h2>
<mat-dialog-content class="mat-typography">
  <div class="form-content mt-2">
    <form [formGroup]="cardForm">
      <div class="form-group mb-2">
        <label for="creditCardNumber"
          >{{ multilingualService.langMap?.LABEL_CREDIT_CARD_NO
          }}<span class="text-primary text-w-600">*</span></label
        >
        <div class="card-input">
          <input
            id="creditCardNumber"
            type="tel"
            mask="0000 0000 0000 0000"
            placeholder="xxxx xxxx xxxx xxxx"
            formControlName="creditCardNumber"
            class="form-control"
            onCopy="return false"
            onPaste="return false"
          />
          <span>
            <img
              *ngIf="creditCardType.value == 'MASTERCARD'"
              src="assets/images/mastercard.svg"
              alt="MASTERCARD"
            />
            <img
              *ngIf="creditCardType.value == 'VISA'"
              src="assets/images/visa.svg"
              alt="VISA"
            />
            <img
              *ngIf="creditCardType.value == 'DISCOVER'"
              src="assets/images/discover.svg"
              alt="Discover"
            />
            <img
              *ngIf="creditCardType.value == 'AMERICAN_EXPRESS'"
              src="assets/images/american-express.svg"
              alt="American Express"
            />
          </span>
        </div>
        <span
          *ngIf="
            creditCardNumber?.errors?.required && creditCardNumber?.touched
          "
          role="alert"
          class="text-danger"
          >{{
            multilingualService.langMap?.ERROR_MSG_ENTER_CREDIT_CARD_NO
          }}</span
        >
        <span
          *ngIf="
            creditCardNumber?.errors?.minlength && creditCardNumber?.touched
          "
          role="alert"
          class="text-danger"
          >{{
            multilingualService.langMap?.ERROR_MSG_ENTER_CREDIT_CARD_NO
          }}</span
        >
      </div>
      <div class="form-group mb-2">
        <label for="creditCardType"
          >{{ multilingualService.langMap?.LABEL_CREDIT_CARD_TYPE
          }}<span class="text-primary text-w-600">*</span></label
        >
        <div class="select-box">
          <select
            id="creditCardType"
            formControlName="creditCardType"
            class="form-control"
          >
            <option value="AMERICAN_EXPRESS">AMERICAN EXPRESS</option>
            <option value="DISCOVER">DISCOVER</option>
            <option value="MASTERCARD">MASTERCARD</option>
            <option value="VISA">VISA</option>
          </select>
        </div>
        <span
          *ngIf="creditCardType?.errors?.required && creditCardType?.touched"
          role="alert"
          class="text-danger"
          >{{ multilingualService.langMap?.ERROR_MSG_SELECT_CARD_TYPE }}</span
        >
      </div>
      <div class="form-group mb-2">
        <!-- <label>Default Card Indicator</label> -->
        <mat-slide-toggle
          id="defaultCardIndicator"
          formControlName="defaultCardIndicator"
          >{{
            multilingualService.langMap?.LABEL_USE_DEFAULT
          }}</mat-slide-toggle
        >
        <!-- <input formControlName="defaultCardIndicator" type="text" class="form-control" /> -->
      </div>
      <div class="form-group mb-2">
        <label for="expirationDate"
          >{{
            multilingualService.langMap
              ?.LABEL_PRESCRIPTION_DETAILS_EXPIRATION_DATE
          }}
          <span class="text-primary text-w-600">*</span></label
        >
        <input
          #date
          id="expirationDate"
          mask="00/00"
          formControlName="expirationDate"
          (keyup)="onDateChange(date.value)"
          placeholder="MM/YY"
          type="tel"
          class="form-control"
        />
        <span
          *ngIf="expirationDate?.errors?.required && expirationDate?.touched"
          role="alert"
          class="text-danger"
          >{{ multilingualService.langMap?.ERROR_MSG_ENTER_EXP_DATE }}</span
        >
      </div>

      <div class="form-group mb-2">
        <label for="firstNameOnCard"
          >{{ multilingualService.langMap?.LABEL_UPDATE_PROFILE_FORM_FIRST_NAME
          }}<span class="text-primary text-w-600">*</span></label
        >
        <input
          id="firstNameOnCard"
          formControlName="firstNameOnCard"
          type="text"
          class="form-control"
        />
        <span
          *ngIf="firstNameOnCard?.errors?.required && firstNameOnCard?.touched"
          role="alert"
          class="text-danger"
          >{{ multilingualService.langMap?.ERROR_MSG_ENTER_FIRST_NAME }}</span
        >
        <span
          *ngIf="firstNameOnCard?.errors?.pattern && firstNameOnCard?.touched"
          role="alert"
          class="text-danger"
          >{{
            multilingualService.langMap?.ERROR_UPDATE_PROFILE_FIRST_NAME
          }}</span
        >
      </div>
      <div class="form-group mb-2">
        <label for="lastNameOnCard"
          >{{ multilingualService.langMap?.LABEL_UPDATE_PROFILE_FORM_LAST_NAME
          }}<span class="text-primary text-w-600">*</span></label
        >
        <input
          id="lastNameOnCard"
          formControlName="lastNameOnCard"
          type="text"
          class="form-control"
        />
        <span
          *ngIf="lastNameOnCard?.errors?.required && lastNameOnCard?.touched"
          role="alert"
          class="text-danger"
          >{{ multilingualService.langMap?.ERROR_MSG_ENTER_LAST_NAME }}</span
        >
        <span
          *ngIf="lastNameOnCard?.errors?.pattern && lastNameOnCard?.touched"
          role="alert"
          class="text-danger"
          >{{
            multilingualService.langMap?.ERROR_UPDATE_PROFILE_LAST_NAME
          }}</span
        >
      </div>
      <div class="form-group mb-2">
        <label for="addressLine1"
          >{{ multilingualService.langMap?.LABEL_ADD_NEW_ADDRESS_ADDRESS_LINE_1
          }}<span class="text-primary text-w-600">*</span></label
        >
        <input
          id="addressLine1"
          formControlName="addressLine1"
          type="text"
          class="form-control"
        />
        <span
          *ngIf="addressLine1?.errors?.required && addressLine1?.touched"
          role="alert"
          class="text-danger"
          >{{ multilingualService.langMap?.ERROR_MSG_ENTER_ADDRESS1 }}</span
        >
      </div>
      <div class="form-group mb-2">
        <label for="addressLine2">{{
          multilingualService.langMap?.LABEL_ADD_NEW_ADDRESS_ADDRESS_LINE_2
        }}</label>
        <input
          id="addressLine2"
          formControlName="addressLine2"
          type="text"
          class="form-control"
        />
      </div>
      <div class="form-group mb-2">
        <label for="city"
          >{{ multilingualService.langMap?.LABEL_ADD_NEW_ADDRESS_CITY }}
          <span class="text-primary text-w-600">*</span></label
        >
        <input
          id="city"
          formControlName="city"
          type="text"
          class="form-control"
        />
        <span
          *ngIf="city?.errors?.required && city?.touched"
          role="alert"
          class="text-danger"
          >{{ multilingualService.langMap?.ERROR_MSG_ENTER_CITY }}</span
        >
      </div>
      <div class="form-group mb-2">
        <label for="state"
          >{{ multilingualService.langMap?.LABEL_ADD_NEW_ADDRESS_STATE }}
          <span class="text-primary text-w-600">*</span></label
        >
        <div class="select-box">
          <select id="state" formControlName="state" class="form-control">
            <option *ngFor="let state of states" [value]="state.value">
              {{ state.name }}
            </option>
          </select>
        </div>
        <span
          *ngIf="state?.errors?.required && state?.touched"
          role="alert"
          class="text-danger"
          >{{ multilingualService.langMap?.ERROR_MSG_ENTER_STATE }}</span
        >
      </div>
      <div class="form-group mb-2">
        <label for="zipCode"
          >{{ multilingualService.langMap?.LABEL_ADD_NEW_ADDRESS_ZIPCODE
          }}<span class="text-primary text-w-600">*</span></label
        >
        <input
          id="zipCode"
          [mask]="'00000'"
          formControlName="zipCode"
          type="text"
          class="form-control"
        />
        <span
          *ngIf="zipCode?.errors?.minlength && zipCode?.touched"
          role="alert"
          class="text-danger"
          >{{ multilingualService.langMap?.ERROR_MSG_ENTER_VALID_VALUE }}</span
        >
        <span
          *ngIf="zipCode?.errors?.required && zipCode?.touched"
          role="alert"
          class="text-danger"
          >{{ multilingualService.langMap?.ERROR_MSG_ENTER_ZIPCODE }}</span
        >
      </div>
    </form>
  </div>
</mat-dialog-content>
<div class="bottom-btn justify-content-center mat-dialog-actions">
  <button
    *ngIf="!isLoading"
    [disabled]="cardForm.invalid"
    (click)="addCard()"
    mat-raised-button
    class="primary-button uppercase"
  >
    <span>{{
      multilingualService.langMap?.LABEL_CHANGE_LANGUAGE_CONFIRM
    }}</span>
  </button>
  <button
    *ngIf="isLoading"
    mat-raised-button
    class="primary-button uppercase button-loader"
  >
    <span>
      <img src="assets/images/small-loader.gif" alt="loader" width="25px"
    /></span>
  </button>
</div>

<!-- <div class="center loader-circle" *ngIf="isLoading">
  <img src="assets/images/loader.gif" alt="loader" width="100px" />
</div> -->
<ng-template #error>
  <div class="toaster-bg error d-flex justify-content-center">
    <mat-icon class="icon-error mr-1"></mat-icon>
    <span>{{ errorMsg }}</span>
  </div>
</ng-template>
